import day from 'dayjs';
import { X_Language, isMobile } from '..';
import Tracker from './tracker';

class CommentsTracker extends Tracker {
  /*
   *
   * @desc: 评论页面埋点
   * @param {string} action 事件操作
   * @param {object} eventLabel
   *
   */
  CommentPage = ({ action, product_key, curPage, orderNumber, value = 1, _label = '' }) => {
    try {
      const _isMobile = isMobile();
      const language = X_Language;
      if (!action) return;
      let time = day().format('YYYY-MM-DD HH:mm:ss');
      let label = '';
      switch (true) {
        case ['click_storeBtn'].includes(action):
          label = `${curPage} + ${language} + ${time}`;
          break;
        case ['visit_failure'].includes(action):
          label = `${orderNumber} + ${language} + ${time}`;
          break;
        case ['click_commentBtn'].includes(action):
          label = `${curPage} + ${product_key} + ${language} + ${time}`;
          break;
        default:
          label = `${!!_label ? _label + '_' : ''}${product_key} + ${language} + ${time}`;
      }
      this.commonTracker({
        category: `${_isMobile ? 'mobile' : 'pc'}_comments_commentPage`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 产品页评论埋点
   * @param {string} action 事件操作
   * @param {object} eventLabel
   *
   */
  ProductPage = ({ action, product_key, value = 1, pageNumber, _label }) => {
    if (!action) return;
    try {
      const _isMobile = isMobile();
      const language = X_Language;
      if (!action) return;
      let time = day().format('YYYY-MM-DD HH:mm:ss');
      let label = '';

      switch (true) {
        case action.includes('click_filterList_'):
        case action.includes('click_filterBar'):
          label = `${product_key} + ${_label} + ${language} + ${time}`;
          break;
        case ['page_jump'].includes(action):
          label = `${product_key} + ${pageNumber} + ${language} + ${time}`;
          break;
        default:
          label = `${!!_label ? _label + '_' : ''}${product_key} + ${language} + ${time}`;
      }
      this.commonTracker({
        category: `${_isMobile ? 'mobile' : 'pc'}_comments_productPage`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };
}

const T = new CommentsTracker();
export default T;
